export default class Location {

    constructor() {

    }
    init() {
        let CyrLat = new CyrLatConverter('body').init({
            onClickCyr: '#cyrButton',
            onClickLat: '#latButton',
            // onClickDefault: '#cyr',
            cookieDuration: '7',
            usePermalinkHash: true,
            permalinkHashLat: '#lat',
            permalinkHashCyr: '#cyr',
            ignoreClasses: ['ignore'],
            benchmark: false,
            // benchmarkEval: "document.getElementById('exctime').innerHTML = '%s%';"
            onC2L: function () {
                jQuery('#latButton').parent().addClass('is-active');
                jQuery('#cyrButton').parent().removeClass('is-active');
            },
            onL2C: function () {
                jQuery('#latButton').parent().removeClass('is-active');
                //jQuery('#cyrButton').parent().addClass('is-active');

                let expires = "; ";
                let value = "Default";
                document.cookie = "CyrLatConverterSelected=" + value + expires + "path=/";

                window.location.hash = '';

                location.reload();
            },
        });

    }
}



// WEBPACK FOOTER //
// ./static/js/components/LanguageSwitcher.js